import request from '@/utils/axios'
import qs from 'qs'

export function getEventInfo(params){
    let postData = qs.stringify(params)
    return request({
      url: '/api/manager/event/getEventInfo',
      method: 'post',
      data:postData
    })
  }
  
  export function addEvent(params){
    let postData = qs.stringify(params)
    return request({
      url: '/api/manager/event/addEvent',
      method: 'post',
      data:postData
    })
  }
  
  export function updateEvent(params){
    let postData = qs.stringify(params)
    return request({
      url: '/api/manager/event/editEvent',
      method: 'post',
      data:postData
    })
  }
  
  export function deleteEvent(params){
    let postData = qs.stringify(params)
    return request({
      url: '/api/manager/event/deleteEvent',
      method: 'post',
      data:postData
    })
  }
  
  export function batchDeleteEvent(params){
    let postData = qs.stringify(params)
    return request({
      url: '/api/manager/event/batchDeleteEvent',
      method: 'post',
      data:postData
    })
  }